export const breakpoints: any = {
  xs: '100px',
  sm: '600px',
  md: '960px',
  lg: '1280px',
  xl: '1920px',
};

export const breakpointsNumeric = {
  xs: 100,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920,
};
